import React from "react";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}

export const CustomInput: React.FC<InputProps> = ({
  className = "",
  ...props
}) => {
  const baseClasses =
    "rounded border border-[#494C56] bg-[#292930] flex p-3 flex-col justify-center items-start gap-2 w-full text-white placeholder-gray-400 focus:outline-none focus:border-gray-300 focus:shadow-none outline-none transition-all duration-200 hover:border-[#5a5d66] ";

  const combinedClasses = `${baseClasses} ${className}`;

  return <input className={combinedClasses} {...props} />;
};
